namespace GeniuzPOS.Purchase {
    export namespace PoPo05PendingPIforIrService {
        export const baseUrl = 'Purchase/PoPo05PendingPIforIr';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PoPo05PendingPIforIrRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PoPo05PendingPIforIrRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Purchase/PoPo05PendingPIforIr/Retrieve",
            List = "Purchase/PoPo05PendingPIforIr/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PoPo05PendingPIforIrService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
